import { useSelector } from 'react-redux'

import {
  LabelInput,
  EntryTypeSelect,
  HideOnPdfToggle,
  ReadOnlyToggle,
  RequiredToggle,
  DefaultValueInput,
  StandardFieldConfig,
  StandardDesignConfig,
} from 'apps/studio/components/settings/fields/Base/standard'
import {
  validateMinMaxDecimal,
  validateMinMaxNumber,
} from 'apps/builder/lib/minMaxValidations'

import { allEntryTypesSelector } from 'apps/formsCreationKit/store/selectors/types'
import { lib } from '@gocanvas/client'
const { NUMBER_STYLE, CURRENCY_STYLE, isNumber } = lib

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

const NumberStyleSelect = {
  label: 'Style',
  settingType: 'selectInput',
  updateType: 'entry',
  property: 'style',
  dynamicChoices: () => {
    const entryTypes = useSelector(allEntryTypesSelector)

    const { id: integer_type_id } = entryTypes.find(
      ({ original_type_id }) => original_type_id == 1
    )
    const { id: decimal_type_id } = entryTypes.find(
      ({ original_type_id }) => original_type_id == 2
    )
    return [
      {
        label: 'Number',
        value: NUMBER_STYLE,
        additionalProperties: {
          mask: '0',
          entry_type_id: decimal_type_id,
          original_type_id: 2,
        },
      },
      {
        label: 'Increment',
        value: 1,
        additionalProperties: {
          mask: '0',
          entry_type_id: integer_type_id,
          original_type_id: 1,
        },
      },
      {
        label: 'Slider',
        value: 2,
        additionalProperties: {
          mask: '0',
          entry_type_id: integer_type_id,
          original_type_id: 1,
        },
      },
      {
        label: 'Currency',
        value: CURRENCY_STYLE,
        additionalProperties: {
          mask: '2',
          entry_type_id: decimal_type_id,
          original_type_id: 2,
        },
      },
    ]
  },
}

const NumberDefaultValueInput = {
  ...DefaultValueInput,
  settingType: 'numberInput',
  updateType: 'entry',
  additionalProps: data => {
    const { minimum, maximum } = data
    return {
      max: maximum,
      min: minimum,
    }
  },
}

const selectedValidation = (field, property) => {
  if (parseInt(field.mask) != 0) {
    return validateMinMaxDecimal(field, property)
  } else {
    return validateMinMaxNumber(field, property)
  }
}

const MinimumInput = {
  label: 'Minimum',
  settingType: 'numberInput',
  updateType: 'entry',
  property: 'minimum',
  validation: data => {
    return {
      errors: selectedValidation(data, 'minimum'),
    }
  },
  additionalProps: data => {
    const { maximum, default: defaultValue } = data
    const maxAllowed = [defaultValue, maximum].filter(isNumber)
    return {
      // min can't be higher than default or max
      max: maxAllowed.length ? Math.min(...maxAllowed) : undefined,
    }
  },
}

const MaximumInput = {
  label: 'Maximum',
  settingType: 'numberInput',
  updateType: 'entry',
  property: 'maximum',
  validation: data => {
    return {
      errors: selectedValidation(data, 'maximum'),
    }
  },
  additionalProps: data => {
    const { minimum, default: defaultValue } = data
    const minAllowed = [defaultValue, minimum].filter(isNumber)
    return {
      // max can't be lower then default or minimum
      min: minAllowed.length ? Math.max(...minAllowed) : undefined,
    }
  },
}

export const NumberStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  NumberStyleSelect,
  SettingsLabel('Config'),
  NumberDefaultValueInput,
  MinimumInput,
  MaximumInput,
  RequiredToggle,
  ReadOnlyToggle,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]

export const IncrementStandardSettings = NumberStandardSettings
export const CurrencyStandardSettings = NumberStandardSettings

// cannot be required
export const SliderStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  NumberStyleSelect,
  SettingsLabel('Config'),
  NumberDefaultValueInput,
  MinimumInput,
  MaximumInput,
  ReadOnlyToggle,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]
